import { typography } from '@joor/design-system'
import styled from 'styled-components'

export const PaymentsContainer = styled.div`
  margin-top: var(--actual-navbar-top-displacement);
`

export const PageHeaderContainer = styled.div`
  padding: 25px 20px;
  border-bottom: 1px solid var(--color-primary-200);
  margin-bottom: 20px;
`

export const PageHeaderTitle = styled.div`
  ${typography.alpha.primaryActive.body2};
  color: var(--color-primary-400);
`

export const PageHeaderInfo = styled.p`
  ${typography.alpha.primaryActive.subtitle3};
`

export const StyledLink = styled.a`
  ${typography.alpha.link.body3};
  display: block;
`

export const WarningBannerWrapper = styled.div`
  margin-bottom: 16px;
`
